import { getFilePath, getRoot } from "@enfusion-ui/core";
import { encodeFilePath } from "@enfusion-ui/utils";
import { omit } from "lodash";
import queryString from "query-string";
import { restServer } from "./restServer";
import { errorToast, successToast } from "./toast";
export const sortByName = (a, b) => a.name.localeCompare(b.name);
export const isSupportedReport = (i) => !i.name.endsWith(".diff"); // .diff reconciliation reports aren't supported yet
export const fileTreeEntriesToNodeData = (entries, recurseOnChildren = false) => {
    const directories = entries.filter((i) => !i.file);
    const childFiles = entries.filter((i) => i.file);
    const files = childFiles.filter(isSupportedReport);
    return [...directories, ...files].map((i) => ({
        ...omit(i, ["children"]),
        id: i.path,
        nodes: recurseOnChildren && i.children
            ? fileTreeEntriesToNodeData(i.children, true)
            : undefined,
    }));
};
export const fileTreeEntriesToSortedNodeData = (entries, recurseOnChildren = false) => {
    const childDirectories = entries.filter((i) => !i.file);
    const childFiles = entries.filter((i) => i.file);
    const directories = childDirectories.sort(sortByName);
    const files = childFiles.sort(sortByName).filter(isSupportedReport);
    return [...directories, ...files].map((i) => ({
        ...i,
        id: i.path,
        nodes: recurseOnChildren && i.children
            ? fileTreeEntriesToSortedNodeData(i.children, true)
            : undefined,
    }));
};
export const getSearchRootNode = async (base, root, searchTerm, abortController) => {
    try {
        const rootData = await restServer(`/internal/api/documents/${base}/search/${root}?searchText=${encodeURIComponent(searchTerm)}`, { signal: abortController?.signal });
        return rootData?.children
            ? fileTreeEntriesToSortedNodeData(rootData.children, true)
            : [];
    }
    catch (err) {
        console.error("REMOTE FILE DETAIL SEARCH ERROR", err);
        throw new Error("Failed to get root node search results");
    }
};
export const getRootNode = async (path, nodePath, abortController) => {
    try {
        const rootData = await restServer(queryString.stringifyUrl({
            url: encodeFilePath(path),
            query: {
                root: getRoot(nodePath),
                path: encodeFilePath(nodePath.includes("/") ? getFilePath(nodePath) : ""),
            },
        }), {
            signal: abortController?.signal,
        });
        return rootData?.children
            ? fileTreeEntriesToSortedNodeData(rootData.children)
            : [];
    }
    catch (err) {
        console.error("REMOTE FILE DETAIL ERROR", err);
        throw new Error("Failed to get root node");
    }
};
export const retrieveNodes = (base, list = false) => (node) => {
    const nodeData = (typeof node === "string" ? { path: node } : node);
    return getRootNode(`/internal/api/documents/v2/${base}${list ? "/list" : ""}`, nodeData.path);
};
export const deleteFile = async (filePath, onSuccess) => {
    try {
        await restServer(`/internal/api/documents/dashboards/delete/${encodeFilePath(filePath)}`);
        successToast("Deleted File Successfully!");
        if (onSuccess) {
            onSuccess();
        }
    }
    catch (error) {
        errorToast("File was unable to be deleted");
        console.error(error);
    }
};
